
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
import { thirdPartyServiceUrl } from '@/settings'
const qrCodePay = () => import('@/components/qrCodePay')
import { mapGetters } from 'vuex'

export default {
	components: {
		Breadcrumb,
		TitleBox,
		TitleBox2,
		qrCodePay
	},
	data() {
		return {
			parChangeState: true, // 勾选协议
			centerDialogVisible1: false, //取消订单
			centerDialogVisible2: false, // 购买须知
			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			detailsData: null, // 商品信息
			compensationList: [], //包赔列表
			compensationListTwo: [], //包赔列表
			compensationFee: '未包赔', //包赔金额
			compensationId: null, //包赔id
			compensationName: null, //包赔名称
			parInfo: {}, //创建订单回调信息
			articleDetail: null, //购买须知
			orderData: {},
			// 工单区分3.0 2.0
			// templateId: null,
			orderActive: false,
			compensationVisible: false, // 包赔信息弹窗
			valueAddCompensationIds: [], //增值包赔id合集
			compensationDetail: '', //包赔规则
			compensationAttentionItems: '', // 注意事项
			compensationVisibleData: '', // 包赔弹窗选中数据
			// 是否必选包赔
			compensation: {
				compensationAddNeed: null, //是否必选增值包赔
				compensationBasicNeed: null //是否必选基础包赔
			},
			couponList: [], //优惠卷列表
			usedcoupon: {}, // 选中要使用的优惠券
			couponTipsModalShow: false, // 优惠券使用提示弹框
			couponLoading: false, // 获取优惠券的loading
			couponNum: 0, //记录默认最高金额优惠券
			dialogTitle: '购买协议',
			inviteInfo:{},
            inviteCode:''
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			gameList: 'game/gameList',
			payInfo: 'game/payInfo',
			userAccount: 'user/userAccount'
		}),
		valueAddCompensationIdsPrice() {
			let nuber = 0
			this.valueAddCompensationIds.map(item => {
				nuber += item.compensationFee
			})
			return nuber
		},
		// 优惠券实际价格
		couponRealPricre() {
			if (this.usedcoupon) {
				let _discountAmount = Number(this.usedcoupon?.couponsValue || 0)
				const GuaranteedPrice = Number(this.compensationFee) + Number(this.valueAddCompensationIdsPrice)
				// 券可用业务 1：包赔费用、2：订单总价
				if (Number(this.usedcoupon.scopeBusiness) === 1) {
					return Math.min(GuaranteedPrice.toFixed(2), _discountAmount)
				} else if (Number(this.usedcoupon.scopeBusiness) === 2) {
					const totalPrice = Number(this.orderData?.bargainPrice) + GuaranteedPrice
					return Math.min(totalPrice.toFixed(2), _discountAmount)
				}
				return 0
			}
		},
		// 模板上显示总价
		setTotal() {
			// 总价 - 优惠券实际减免金额
			let total = Number(this.orderData?.bargainPrice) - this.couponRealPricre
			if (this.compensationFee === '未包赔') {
				return total < 0 ? 0 : total
			} else {
				total += this.compensationFee + Number(this.valueAddCompensationIdsPrice)
			}
			return total < 0 ? 0 : total.toFixed(2)
		},
		// 拆分总价的整数和小数
		disassemblePrice() {
			const _price = String(this.setTotal)?.split('.')
			return [_price[0], _price[1] || '00']
		},
		selectCompensationList() {
			const result = []
			if (this.compensationId) result.push({ name: this.compensationName, price: this.compensationFee, key: this.compensationId })
			if (this.valueAddCompensationIds.length) {
				this.valueAddCompensationIds.forEach(item => {
					result.push({ name: item.name, price: item.compensationFee, key: item.id })
				})
			}
			return result
		},
		// 是否展示承保告知书
		showCompensationNotice() {
			return this.compensationId || this.valueAddCompensationIds.length > 0
		}
	},
	methods: {
		async getGoodsDetail() {
			const res = await this.$api.goodsDetails({
				action: {
					goodsNo: this.$route.query.goodsNo
				}
			})
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			this.detailsData = res.data
		},
		// 购买须知勾选
		parChange() {
			this.parChangeState = !this.parChangeState
		},
		// 购买须知我已知晓
		onKnown() {
			this.parChangeState = true
			this.centerDialogVisible2 = false
		},
				// 推广码输入限制 - 与表单数据双向绑定
		handleInviteCodeInput(event) {
			const value = event
			// 只允许数字和字母，并限制8位
			const filteredValue = value.replace(/[^0-9a-zA-Z]/g, '').substring(0, 8)
			// 更新到表单数据中
			this.inviteCode = filteredValue
			// 更新输入框显示
			event = filteredValue
		},

		checkCode(){
	        if (!this.inviteCode) return
			this.$api.checkActivityBenefitInviteCode(this.inviteCode).then(res=>{
				if(!res.data){
					this.$message.error('推广码不存在或已过期！')
				}
			})
		},

		handleInviteCodeKeypress(event){
			const char = String.fromCharCode(event.which)
			// 如果不是数字或字母，阻止输入
			if (!/[0-9a-zA-Z]/.test(char)) {
				event.preventDefault()
			}
			// 如果已经达到8位，阻止继续输入
			if (this.inviteCode && this.inviteCode.length >= 8) {
				event.preventDefault()
			}
		},
		paymentSubmitData(data) {
			this.$api.bargainImCreateOrderAPI({...data, commonCreate: this.orderData.fromGoodsDetail}).then(res => {
				if (res.success) {
					// 创建订单成功后续处理
					this.parInfo = {
						...res.data,
						payTotalMoney: res.data.payMoney,
						transactionGoodsPrice: this.orderData.bargainPrice
					}
					this.centerPayDialogVisible = true
					this.$nextTick(() => {
						this.$refs['orderPayRef'].getPayqrCodeUrl(this.parInfo)
					})
				} else {
          if (res.code === 'BARGAIN_IM_EXPIRE' || res.code === 'FAILED') {
            this.$alert(res.info, '提示', {
              confirmButtonText: '我知道了',
              dangerouslyUseHTMLString: true,
              type: 'error',
              showClose: false
            }).then(() => {
              this.$api.getCheckGoodsStatus({ goodsNo: this.detailsData.goodsNo }).then(res => {
                if (res.success) {
                  if (thirdPartyServiceUrl && this.userinfo.id) {
                    sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
                    this.$router.replace({
                      path: '/confirmOrder/fullPayment',
                      query: {
                        status: res.data ? 'WAIT_PAY' : 'null',
                        orderNo: res.data,
                        gameId: this.detailsData.gameId,
                        goodsNo: this.detailsData.goodsNo
                      }
                    })
                  }
                } else {
                  // 提示商品状态
                  this.$message.error(res.info)
                }
              })
            })
          }
          else {
					  this.$message.error(res.info)
          }
				}
			})
		},
		// 检查是否被限制购买商品
		async onCheckLimit() {
			const par = {
				action: {
					userBizLimited: 'PROXY_AGENCY_CREATE_ORDER'
				}
			}
			const check = await this.$api.checkOrderLimit(par)
			if (!check.data) {
				this.$message.error(check.info)
				return false
			}
			return true
		},
		// 立即支付
		async paymentSubmit() {
			const check = await this.onCheckLimit()
			if (!check) return
			if (this.parChangeState == false) {
				this.$message.error('请阅读并勾选购买须知')
				return
			}
			// 商品不支持包赔。直接创建订单
			if (!this.detailsData?.compensation) {
				let data = {
					action: {
						compensationId: null,
						bargainOrderNo: this.orderData?.bargainOrderNo,
						valueAddCompensationIds: null,
						couponsCode: null
					}
				}
				this.paymentSubmitData(data)
				return
			}
			// 有可用优惠卷但是未使用
			const _canUseCoupon = this.couponList?.some(res => res.canUse)
			if (_canUseCoupon && !this.usedcoupon.hasOwnProperty('id')) {
				this.couponTipsModalShow = true
			} else {
				this.paymentSubmitToCreatOrder()
			}
		},

		// 创建订单
		async paymentSubmitToCreatOrder() {
			let _valueAddCompensationIds = null
			if (this.valueAddCompensationIds.length > 0) {
				_valueAddCompensationIds = []
				this.valueAddCompensationIds.map(item => {
					_valueAddCompensationIds.push(item.id)
				})
			}
			let data = {
				action: {
					compensationId: this.compensationId,
					bargainOrderNo: this.orderData?.bargainOrderNo,
					valueAddCompensationIds: _valueAddCompensationIds,
					couponsCode: this.usedcoupon?.couponsCode, // 使用的优惠券编码
					inviteCode: this.inviteCode
				}
			}
			// 是否包赔服务必选
			if (!this.compensation.compensationBasicNeed && !this.compensation.compensationAddNeed) {
				// 是否选择了包赔 没有选择则弹窗
				if (data.action.compensationId || data.action.valueAddCompensationIds) {
					this.paymentSubmitData(data)
				} else if (!this.compensationList.length) {
					this.paymentSubmitData(data)
				} else {
					const model = this.$pzDialog({
						title: '确认信息',
						content: '账号交易有发生找回的风险，若发生找回，平台将全力助您追回账号，若无法追回，平台将赔付30%号款。',
						top: '15vh',
						width: '450px',
						cancelButtonText: '我已知晓',
						confirmButtonText: '返回加购',
						onConfirm: () => {
							model.remove()
						},
						onCancel: () => {
							this.paymentSubmitData(data)
							model.remove()
						}
					})
				}
			} else {
				if (this.compensation.compensationBasicNeed && this.compensation.compensationAddNeed) {
					if (!this.compensationList.length || !this.compensationListTwo.length) {
						this.$message.error('包赔服务错误，请联系客服')
						return
					} else if (!data.action.compensationId && !data.action.valueAddCompensationIds) {
						this.$message.error('该商品需要至少加购一个【基础包赔类型+增值包赔类型】服务')
						return
					} else if (!data.action.compensationId) {
						this.$message.error('该商品需要至少加购一个【基础包赔类型】服务')
						return
					} else if (!data.action.valueAddCompensationIds) {
						this.$message.error('该商品需要至少加购一个【增值包赔类型】服务')
						return
					}
				}
				// 调用检查函数
				const isBasicCompensationValid = this.checkCompensation(
					this.compensation.compensationBasicNeed,
					this.compensationList,
					data.action.compensationId,
					'该商品需要至少加购一个【基础包赔类型】服务'
				)
				const isAddCompensationValid = this.checkCompensation(
					this.compensation.compensationAddNeed,
					this.compensationListTwo,
					data.action.valueAddCompensationIds,
					'该商品需要至少加购一个【增值包赔类型】服务'
				)
				// 如果任一包赔类型不通过验证，则返回
				if (!isBasicCompensationValid || !isAddCompensationValid) {
					return
				} else {
					this.paymentSubmitData(data)
				}
			}
		},
		// 包赔是否必填
		checkCompensation(compensationNeed, compensationList, compensationId, errorMessage) {
			if (compensationNeed) {
				if (!compensationList.length) {
					this.$message.error('包赔服务错误，请联系客服')
					return false
				} else if (!compensationId) {
					this.$message.error(errorMessage)
					return false
				}
			}
			return true
		},
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['orderPayRef'].closeDialogVisible()
			// 关闭支付弹窗跳转订单详情页
			if (this.parInfo.orderNo) this.gotoWaitPay()
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				this.$router.push({
					path: '/confirmOrder/paymentCallback',
					query: { orderNo: this.parInfo.orderNo, status: '2' }
				})
			} else {
				this.centerPayDialogVisible = payStatus
				this.$refs['orderPayRef'].closeDialogVisible()
				// 支付失败跳转订单详情页
				if (this.parInfo.orderNo) this.gotoWaitPay()
			}
		},
		// 跳转待支付订单详情
		gotoWaitPay() {
			this.$router.push({
				path: '/account/buyerDetails',
				query: { orderNo: this.parInfo.orderNo, parPage: 'true' }
			})
            // ,templateId: this.detailsData?.workOrderTemplateId
		},
		// 查询包赔列表
		getCompensationList() {
			let data = {
				action: {
					goodsNo: this.detailsData?.goodsNo,
					gameId: this.detailsData?.gameId,
					bargain: true
				}
			}
			this.$api.createOrderCompensationList(data).then(res => {
				if (res.success) {
					if (res?.data?.length) {
						res.data?.map(item => {
							if (item.type == 'BASIC_COMPENSATION') {
								this.compensationList = this.pushData(item?.compensationServiceApiVOList)
								this.compensationFee = this.compensationList[0]?.compensationFee
								this.compensationId = this.compensationList[0]?.id
								this.compensationName = this.compensationList[0]?.name
                this.compensationList[0].isSelected = true
							} else if (item.type == 'VALUE_ADD_COMPENSATION') {
                this.compensationListTwo = this.pushData(item?.compensationServiceApiVOList)

                // 如果开启必须选择增值包赔，则默认选中第一个增值包赔
                if (this.compensation.compensationAddNeed) {
                  this.compensationListTwo[0].isSelected = true
                  this.valueAddCompensationIds = [this.compensationListTwo[0]]
                }
							}
						})
						this.getWaitUseCouponList()
					}
				} else {
					this.$message.error(res.info)
				}
			})
		},
		/**
		 * @description 查询可用优惠券列表
		 * @param compensationId 包赔ID
		 */
		getWaitUseCouponList() {
			const price = this.orderData?.bargainPrice
			const par = {
				gameId: this.orderData?.gameId,
				price,
				baseCompensationFee: 0,
				addCompensationFee: 0,
				compensationId: null
			}
			if (this.compensationId) {
				par.compensationId = this.compensationId
				par.baseCompensationFee = Number(this.compensationFee) || 0
				let addCompensationFee = 0
				if (this.valueAddCompensationIds.length) {
					this.valueAddCompensationIds.forEach(item => {
						addCompensationFee += Number(item.compensationFee)
					})
				}
				par.addCompensationFee = Number(addCompensationFee.toFixed(2)) || 0
			}
			this.couponLoading = true
			this.$api
				.getWaitUseCouponList(par)
				.then(({ success, data }) => {
					this.couponList = success ? data : []
					let arrA = this.couponList.filter(item => item.canUse)
					if (!arrA.length) {
						this.usedcoupon = {}
						return
					}
					// let arrB = arrA.reduce((max, item) => (max.couponsValue > item.couponsValue ? max : item))
					let arrB = arrA.reduce((prev, current) => {
						const prevDiscount = this.calculateDiscount(prev)
						const currentDiscount = this.calculateDiscount(current)
						// 比较两个优惠券的实际抵扣金额，选择更高的
						return prevDiscount > currentDiscount ? prev : current
					})
					arrB && this.onSelectCoupon(arrB, true)
					this.couponNum = 1
				})
				.finally(() => (this.couponLoading = false))
		},
		calculateDiscount(coupon) {
			// 提前将数据解析并缓存，避免重复操作
			const compensationPrice = this.selectCompensationList.reduce((total, item) => total + Number.parseFloat(item.price || 0), 0)
			const couponValue = Number.parseFloat(coupon.couponsValue || 0)
			const scopeBusiness = Number.parseInt(coupon.scopeBusiness, 10)
			if (scopeBusiness === 1) {
				// 适用于包赔费用
				return Math.min(compensationPrice, couponValue)
			} else if (scopeBusiness === 2) {
				// 适用于订单总价
				const basicPrice = Number.parseFloat(this.orderData?.bargainPrice || 0)
				const totalPrice = basicPrice + compensationPrice
				return Math.min(totalPrice, couponValue)
			}
			// 默认返回 0（未知业务类型）
			return 0
		},
		pushData(item) {
			item.map(i => {
				i.isSelected = false
			})
			return item
		},
		// 选中包赔
    clickSelected(val, ind) {
      // 如果开启必须选择基础包赔，则必须选择
      if (this.compensation.compensationBasicNeed && this.compensationId == val.id) {
        // this.$message.error('因追回严重，为了您的账号安全，必须购买增值包赔')
        return
      }

			this.compensationList.map((item, index) => {
				if (ind == index) {
					val.isSelected = !val.isSelected
					if (val.isSelected) {
						// this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = item.compensationFee
						this.compensationId = item.id
						this.compensationName = item.name
						// 选中基础包赔-根据基础包赔ID查询优惠券列表
						// 包赔费为0时清空默认选中最高金额优惠券并重置计数器
						if (!this.compensationFee) {
							this.couponNum = 0
							this.usedcoupon = {}
						}
					} else {
						// 取消基础包赔-也要查询优惠券
						this.usedcoupon = {}
						this.couponNum = 3
						// this.couponList = []
						// this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = '未包赔'
						this.compensationId = null
						this.valueAddCompensationIds = []
						this.compensationListTwo.map((twoItem, twoIndex) => {
							twoItem.isSelected = false
						})
					}
				} else {
					item.isSelected = false
				}
			})
			this.getWaitUseCouponList()
		},
		// 多选包赔
		clickCheckbox(val, i) {
      if (this.compensationFee == '未包赔') return this.$message.error('须选择基础包赔后才可加购增值包赔')

      // 如果开启必须选择增值包赔，至少选择一个
      if (this.compensation.compensationAddNeed && this.valueAddCompensationIds.length == 1 && this.valueAddCompensationIds.includes(val)) {
        // this.$message.error('因追回严重，为了您的账号安全，必须购买增值包赔')
        return
      }

			this.compensationListTwo.map((item, index) => {
				if (i == index) {
					val.isSelected = !val.isSelected
					if (item.isSelected) {
						this.valueAddCompensationIds.push(item)
					}
				}
				if (!item.isSelected) {
					this.valueAddCompensationIds.map((idItem, idIndex) => {
						if (item.id == idItem.id) {
							this.valueAddCompensationIds.splice(idIndex, 1)
						}
					})
				}
			})
			this.getWaitUseCouponList()
		},
		// 选择优惠券
		onSelectCoupon(item, state) {
			if (state) {
				if (item.id != this.usedcoupon.id) {
					++this.couponNum
				} else if (item.id === this.usedcoupon.id && this.couponNum === 1) {
					++this.couponNum
				}
			}
			this.usedcoupon = !item?.selected ? item : {}
			this.couponList = this.couponList.map(res => {
				if (res?.id === item?.id) {
					return { ...res, selected: !res.selected }
				} else {
					return { ...res, selected: false }
				}
			})
		},
		/**
		 * 选择是否使用优惠券
		 * @param type creat 不使用优惠券，直接创建订单
		 */
		onWhetherToUseCoupons(type) {
			this.closeModal()
			if (type === 'creat') {
				// 创建订单
				this.paymentSubmitToCreatOrder()
			}
		},
		// 关闭优惠卷使用提示弹框
		closeModal() {
			this.couponTipsModalShow = false
		},
		// 查看购买须知
		getNotice(id, title) {
			this.dialogTitle = title
			let data = {
				action: {
					id
				}
			}
			this.$api.articleDetail(data).then(res => {
				if (res.success) {
					this.articleDetail = res.data
					this.centerDialogVisible2 = true
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 查看支付须知
		getPayNotice(id, title) {
			this.dialogTitle = title
			let data = {
				action: {
					id
				}
			}
			this.$api.getHagglingDetail(data).then(res => {
				if (res.success) {
					this.articleDetail = res.data
					this.centerDialogVisible2 = true
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 查看包赔说明
		compensationVisibleShow(item, index) {
			this.compensationDetail = item.detail
			this.compensationAttentionItems = item.attentionItems
			this.compensationVisibleData = item
			this.compensationVisible = true
		},
		// 单选包赔弹窗确认
		compensationVisibleCheck() {
			this.compensationList.map(item => {
				if (this.compensationVisibleData.id == item.id) {
					item.isSelected = true
					if (item.isSelected) {
						// this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = item.compensationFee
						this.compensationId = item.id
						this.compensationName = item.name
					} else {
						// this.totalPrice = this.detailsData.price || this.detailsData.transactionPrice
						this.compensationFee = '未包赔'
						this.compensationId = null
						this.valueAddCompensationIds = []
						this.compensationListTwo.map((twoItem, twoIndex) => {
							twoItem.isSelected = false
						})
					}
				} else {
					item.isSelected = false
				}
			})
			this.compensationVisible = false
		},
		// 多选包赔弹窗确认
		compensationVisibleCheckTwo() {
			if (this.compensationFee == '未包赔') return this.$message.error('须选择基础包赔后才可加购增值包赔')
			this.compensationListTwo.map(item => {
				if (this.compensationVisibleData.id == item.id) {
					item.isSelected = true
					if (item.isSelected) {
						if (this.valueAddCompensationIds.length <= 0) {
							this.valueAddCompensationIds.push(item)
						} else {
							let _push = false
							this.valueAddCompensationIds.map((idItem, idIndex) => {
								if (idItem.id != item.id) {
									_push = true
								} else {
									_push = false
								}
							})
							if (_push) {
								this.valueAddCompensationIds.push(item)
							}
						}
					}
				}
			})
			this.compensationVisible = false
		},
        async getCouponList() {
            let data = {
                action: {
                    gameId: this.detailsData?.gameId,
                    goodsCatalogueId: this.detailsData?.goodsCatalogueId,
                    goodsNo: this.detailsData?.goodsNo
                }
            }
            const res = await this.$api.getGameConfig(data)
            if (!res.success) {
				this.$message.error(res.info)
				return
			}
            this.compensation = res.data[0]
        }
	},
	async mounted() {
		this.orderData = JSON.parse(sessionStorage.getItem('orderDtl'))
		// this.gameList.map(v => {
		// 	if (v.id == this.orderData?.gameId) {
		// 		this.compensation = {
		// 			compensationAddNeed: v.compensationAddNeed, //是否必选增值包赔
		// 			compensationBasicNeed: v.compensationBasicNeed //是否必选基础包赔
		// 		}
		// 	}
		// })
		// 获取商品详情
		await this.getGoodsDetail()
        await this.getCouponList()
		this.getCompensationList()
		// this.checkWorkOrderTemplate()

		this.$api.getActivityBenefitInviteCode({ gameId: this.$route.query?.gameId || this.detailsData.gameId }).then(res => {
			if (res.success) {
                console.log(res,'res');
                
				this.inviteInfo = res.data
			    // 将邀请码同步到表单数据中
				this.inviteCode = res.data.inviteCode || ''
	     	}
	    })
	}
}
